/* eslint-disable no-fallthrough */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-return-assign */
/* eslint-disable operator-linebreak */
// import orderList from '../../order-grid/OrderList.vue'
import medicinesList from '../../MedicineList'
import orderDetailList from '../../orderDetailList'
import serviceOrder from '../../../services/orders/OrderService.js'
import serviceProvider from '../../../services/provider/ProviderService.js'
import locationService from '../../../services/location/LocationService'
import serviceDocument from '../../../services/patient/DocumentService.js'
import servicePatient from '../../../services/patient/PatientService'
import { StorageService } from '../../../services/StorageService'
import incomeGroupService from '../../../services/patient/IncomeGroupService'
import patientList from '../patient-list/PatientList.vue'
import serviceCalendar from '../../../services/calendar/serviceCalendar'
import i18n from '../../../i18n/index'
import {
  Money
} from 'v-money'
import dayjs from 'dayjs'
import orderDetailsService from '../../../services/orderDetail/orderDetailsService.js'
import schedulingAppointment from '../schedulingAppointmet/schedulingAppointment.vue'
import AppointmentService from '../../../services/appointment/ServiceAppointment'


export default {
  components: {
    // orderList,
    medicinesList,
    orderDetailList,
    Money,
    patientList,
    schedulingAppointment
  },
  props: ['show'],
  data: () => ({
    dialog: false,
    authorizationsLoaded: false,
    menuDelivery: false,
    rules: {
      required: value => !!value || "El campo es requerido"
    },
    validFormPatient: false,
    validFormOrderDetailList: false,
    validFormNotes: false,
    validFormOrder: false,
    selectOrderCode: "",
    pagination: {},
    isFeatured: false,
    orderTable: {
      searchItems: 0,
      searchTerm: ""
    },
    patient: {
      id: "",
      documentType: "",
      document: "",
      fullname: "",
      address: "",
      cellPhoneNumber: "",
      phoneNumber: "",
      idIncomeGroup: "",
      isPac: false,
      isPolicy: false
    },
    order: {
      id: "",
      status: "",
      number: "",
      deliveryAddress: "",
      orderType: {},
      deliveryDate: "",
      notApplyShippingFee: false
    },
    itemTypeOrder: [
      {
        id: "EXCLUSIVE",
        name: "Exclusivo"
      },
      {
        id: "INTEGRATED",
        name: "Integrado"
      }
    ],
    error: false,
    orderDetail: [],
    // Location selects
    states: [],
    cities: [],
    branches: [],
    scheduleRanges: [],
    location: {
      state: "",
      city: "",
      branch: "",
      scheduleRange: ""
    },
    listMedicine: [],
    patientListData: [],
    documentTypeItems: [],
    createReminder: false,
    addM: false,
    time: 2000,
    snackbar: false,
    showGrid: false,
    dataMedicines: [],
    headers: [
      {
        sortable: true,
        text: "Orden",
        value: "orderCode",
        align: "left"
      },
      {
        sortable: false,
        text: i18n.t("headers.provider"),
        value: "providerId",
        align: "left"
      },
      {
        sortable: false,
        text: "Valor cuota moderadora",
        value: "scaleFee",
        align: "left"
      },
      {
        sortable: false,
        text: "Número de entrega",
        value: "deliveryNumber",
        align: "left"
      },
      {
        sortable: false,
        text: "Acciones",
        value: "actions",
        align: "left",
        name: "actions"
      }
    ],
    selectedScheduleRange: "",
    showOrderNumber: false,
    update: 0,
    money: {
      decimal: ".",
      thousands: ",",
      precision: 0,
      masked: false
    },
    attachment: {
      name: ""
    },
    disableSaveButton: false,
    SCHEDULED_ORDER_STATUS: "SCHEDULED",
    incomeGroupItems: [],
    lastCitySelected: "",
    dontApplyShippingFee: false,
    user: "",
    searchButtonLoading: false,
    fechaAllowed: '',
    nameDissabled: false,
    searchIdentification: '',
    searchIdentificationType: ''
  }),

  created() {
    this.getProviders();
    this.getStates();
    this.getDocuments();
    this.order.orderType = this.itemTypeOrder[0];
    this.getIncomeGroups();
  },
  mounted() {
    this.getUserName();
  },
  methods: {
    getUserName() {
      const user = StorageService.getUserData();
      this.user = user.name;
    },
    contains(arr, id) {
      return arr.some(e => e.id === id);
    },
    getDefaultProviderId() {
      const hasOrderDetails = this.orderDetail.length > 0;
      let providerId = -1;
      const user = StorageService.getUserData();

      if (
        hasOrderDetails &&
        this.order.orderType &&
        this.order.orderType !== ""
      ) {
        if (this.order.orderType === this.itemTypeOrder[0].id) {
          providerId = this.orderDetail[0].providerId;
          // } else if (user.branchType === 'UNIFIED') {
          //   providerId = user.providerId
        } else {
          providerId = StorageService.getIntegratedProvider();
        }
      }

      return providerId;
    },
    getDocuments() {
      serviceDocument.getDocuments().then(response => {
        this.documentTypeItems = response.data;
      });
    },
    getIncomeGroups() {
      incomeGroupService.getAll().then(response => {
        this.incomeGroupItems = response.data;
      });
    },
    async getStates() {
      try {
        const response = await AppointmentService.statesAppointment()
        this.states = response.data
      } catch (error) {
      }
    },

    async getCities() {
      try {
        this.cityIsLoading = true
        const result = await AppointmentService.cityAppointment(this.state)
        this.cities = result.data
        this.cityIsLoading = false
      } catch (error) {
        this.cityIsLoading = false
      }
    },
    // getStates() {
    //   return locationService.getStatesByProvider().then(response => {
    //     this.states = response.data;
    //     if (!this.contains(this.states, this.location.state)) {
    //       this.location.state = "";
    //     }
    //     if (!this.contains(this.cities, this.location.city)) {
    //       this.location.city = "";
    //     }
    //     if (!this.contains(this.branches, this.location.branch)) {
    //       this.location.branch = "";
    //     }
    //     if (!this.contains(this.scheduleRanges, this.location.scheduleRange)) {
    //       this.location.scheduleRange = "";
    //     }
    //   });
    // },
    // getCities() {
    //   if (!this.location.state) return;
    //   return locationService
    //     .getCitiesByProvider(this.location.state)
    //     .then(response => {
    //       this.cities = response.data;
    //       if (!this.contains(this.cities, this.location.city)) {
    //         this.location.city = "";
    //       }
    //       if (!this.contains(this.branches, this.location.branch)) {
    //         this.location.branch = "";
    //       }
    //       if (
    //         !this.contains(this.scheduleRanges, this.location.scheduleRange)
    //       ) {
    //         this.location.scheduleRange = "";
    //       }
    //     });
    // },
    getBranches() {
      if (!this.location.city) return;

      // eslint-disable-next-line eqeqeq
      if (this.lastCitySelected != this.location.city) {
        this.lastCitySelected = this.location.city;
        this.location.scheduleRange = "";
        this.scheduleRanges = [];
      }

      const providerId = this.getDefaultProviderId();
      return locationService
        .getBranchesByCityProviderAndType(
          this.location.city,
          providerId,
          this.order.orderType
        )
        .then(response => {
          this.branches = response.data;
          if (this.branches && this.branches.length > 0) {
            this.location.branch = this.branches[0].id;
            this.location.scheduleRange = "";
            this.getScheduleRanges();
          } else {
            this.showNoCoverageForAnyCity("warning");
          }
        });
    },
    getScheduleRanges() {
      if (!this.location.branch) return;

      return locationService
        .getScheduleRangesByBranch(this.location.branch)
        .then(async response => {
          this.scheduleRanges = response.data.filter(sr => sr.idBranchCity.idCity.id === this.location.city)
          let response2 = await servicePatient.prioritizedPatient(this.searchIdentification, this.searchIdentificationType)
          let patient = response2.data
          if (!patient.code) {
            this.scheduleRanges.forEach(sr => (sr.shippingFee = 0))
          }
          this.scheduleRanges.forEach(sr => (sr.range = `${sr.idScheduleRange.start} - ${sr.idScheduleRange.end}`))
          if (!this.contains(this.scheduleRanges, this.location.scheduleRange)) {
            this.location.scheduleRange = ''
          }
          this.$forceUpdate()
        });
    },
    getProviders() {
      serviceProvider.getProviders().then(response => {
        const integratedProvider = StorageService.getIntegratedProvider();
        this.providerItems = response.data.filter(
          item => item.id !== integratedProvider
        );
      });
    },
    async saveScheduling() {
      if (this.patientListData.length === 0) {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.scheduling.error-no-patients")
        });
        return;
      }

      if (!this.orderDetail || this.orderDetail.length === 0) {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.scheduling.error-no-order-details")
        });
        return;
      }
      if (
        !this.nameNomenclature ||
        !this.numberOne ||
        !this.numberTwo ||
        !this.numbreThree
      ) {
        this.$notify({
          group: "app",
          type: "error",
          text: "Falta un campo en la dirección"
        });
        return;
      }

      let thereIsApplicableOrWatchedMedicines = false;
      const allOrderDetailHasMedicines = this.orderDetail.reduce(
        (hasMedicines, orderDetails) => {
          orderDetails.medicines.forEach(m => {
            thereIsApplicableOrWatchedMedicines =
              thereIsApplicableOrWatchedMedicines || m.isApplicable;
            thereIsApplicableOrWatchedMedicines =
              thereIsApplicableOrWatchedMedicines || m.isWatched;
          });
          return hasMedicines && orderDetails.medicines.length > 0;
        },
        true
      );

      if (!allOrderDetailHasMedicines) {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.scheduling.error-no-medicines")
        });
        return;
      }

      if (thereIsApplicableOrWatchedMedicines) {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.scheduling.error-applicable-medicines")
        });
        return;
      }

      if (this.order.id) {
        if (this.listMedicine.length > 0) {
          let listMedicine = {
            list: this.listMedicine,
            code: this.order.id
          }
          orderDetailsService.deleteMedicine(listMedicine)
            .then(result => {
              if (result.data.statusCode === 500) {
                this.$notify({
                  group: 'app',
                  type: 'warning',
                  text: result.data.message
                })
                return
              }
            })
            .catch(error => {
              console.error(error)
            })
        }
      }

      if (!this.$refs.validFormOrder.validate()) {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.scheduling.error-order-form")
        });
        return;
      }

      this.order.deliveryAddress = `${this.nameNomenclature}  ${this.numberOne} # ${this.numberTwo} - ${this.numbreThree}`
      this.order.nameNomenclature = this.nameNomenclature
      this.order.numberOne = this.numberOne
      this.order.numberTwo = this.numberTwo
      this.order.numbreThree = this.numbreThree

      let formData = {
        patients: this.patientListData,
        orderData: {
          ...this.order,
          orderDetail: this.orderDetail,
          location: this.location
        },
        note: this.note,
        observation: this.observation,
        createReminder: this.createReminder,
        userId: StorageService.getUserData().id
      };
      this.disableSaveButton = true;
      serviceOrder
        .createOrder(formData)
        .then(res => {
          this.order.number = res.data.number;
          if (this.attachment.name !== "" && !this.attachment.fromService) {
            return serviceOrder.uploadAttachment(res.data.id, this.attachment);
          } else {
            return true;
          }
        })
        .then(res => {
          // this.$refs.orderList.getOrders();
          this.showOrderNumber = this.order.id === "";
          this.snackbar = true;
          this.closeOrder();
        })
        .catch(() => {
          this.disableSaveButton = false;
          this.$notify({
            group: "app",
            type: "error",
            text: "Ha ocurrido un error al agendar el pedido"
          });
        });
    },
    deletePatient(document) {
      for (var i = 0; i < this.patientListData.length; i++) {
        if (this.patientListData[i].document === document) {
          this.dataMedicines
            .filter(medicine => medicine.document === document)
            .forEach(medicine => this.deleteOrderDetail(medicine.orderCode));
          this.patientListData.splice(i, 1);
        }
      }
    },

    deleteOrderDetail(id) {
      this.dataMedicines = this.dataMedicines.filter(m => m.orderCode !== id);
      this.orderDetail = this.orderDetail.filter(od => od.orderCode !== id);
      this.listMedicine.push(id);
      if (this.update === 0) {
        this.updateOrderType();
      }
    },

    addOrderDetail(validate, orderId, status) {
      if (!validate) {
        if (!this.orderDetail.some(od => od.orderCode === this.orderCode)) {
          const newOrderDetail = {
            id: orderId,
            orderCode: this.orderCode,
            // eslint-disable-next-line operator-linebreak
            scaleFee:
              typeof this.scaleFee === "string"
                ? parseFloat(this.scaleFee.replace(",", ""))
                : this.scaleFee,
            deliveryNumber: this.deliveryNumber,
            providerId: this.order.providerId,
            providerName: this.providerItems.find(
              p => p.id === this.order.providerId
            ).name,
            status: status || "NO_STATUS",
            paymentType: this.paymentType,
            medicines: []
          };
          this.orderDetail.push(newOrderDetail);

          if (this.update === 0) {
            this.updateOrderType();
          }
          this.$emit("dataOrderDetail", this.orderDetail);
        }
      }
    },
    updateOrderType() {
      const diffProviders = this.orderDetail.reduce((providers, od) => {
        const providerId = od.providerId;

        if (!providers.includes(providerId)) {
          providers.push(providerId);
        }

        return providers;
      }, []);
      const moreThanOneProvider = diffProviders.length > 1;

      const oldOrderType = this.order.orderType;
      this.order.orderType = !moreThanOneProvider
        ? this.itemTypeOrder[0].id
        : this.itemTypeOrder[1].id;

      if (oldOrderType !== this.order.orderType) {
        this.getBranches();
      }
    },
    assignMedicineToOrder(item) {
      this.addM = true;
      this.selectOrderCode = item.orderCode;

      const foundOrder = this.foundCurrentOrder(this.selectOrderCode);

      this.dataMedicines = foundOrder.medicines;
    },
    foundCurrentOrder(id) {
      return this.orderDetail.find(currentOrder => {
        return id === currentOrder.orderCode;
      });
    },
    closeOrder() {
      this.$refs.validFormPatient.reset();
      if (this.$refs.validFormOrder) this.$refs.validFormOrder.reset();
      if (this.$refs.attachButton) this.$refs.attachButton.clear();
      this.isFeatured = false;
      this.createReminder = false;
      this.order.id = "";
      this.patient.id = "";
      this.dataMedicines = [];
      this.orderDetail = [];
      this.dialog = false;
      this.showGrid = false;
      this.showGridAppointment = false;
      this.disableSaveButton = false;
      this.nameDissabled = false;
      this.authorizationsLoaded = false;
      // this.$refs.orderList.getOrders();
      this.patientListData = [];
      this.attachment = {
        name: ""
      };
      this.update = 0;
      this.listMedicine = [];
    },
    addMedicines(validate, medicineId, medicineCondition) {
      if (!validate) {
        const foundOrder = this.foundCurrentOrder(this.selectOrderCode);
        this.isFeatured =
          this.isFeatured ||
          (medicineCondition ? medicineCondition.isFeatured : false);
        this.dataMedicines.push({
          fullname: this.patient.fullname,
          document: this.patient.document,
          id: medicineId,
          plu: this.plu,
          description: this.description,
          count: this.count,
          nextShippingDate: this.nextShippingDate,
          orderCode: this.selectOrderCode,
          providerName: foundOrder.providerName,
          scaleFee: foundOrder.scaleFee,
          deliveryNumber: foundOrder.deliveryNumber,
          status: foundOrder.status,
          isApplicable: medicineCondition
            ? medicineCondition.isApplicable
            : false,
          isWatched: medicineCondition ? medicineCondition.isWatched : false,
          isFeatured: medicineCondition ? medicineCondition.isFeatured : false
        });

        foundOrder.medicines = this.dataMedicines.filter(
          m => m.orderCode === this.selectOrderCode
        );

        this.$emit("dataMedicines", this.dataMedicines);
      }
    },
    async handleOrder(order) {
      if (order.id) {
        this.update = 1;
      }
      let isItLoaded = false;
      this.getAllowedDate();
      order.orderPatients.forEach(orderPatient => {
        let patient = orderPatient.idPatient;
        if (
          this.patientListData.some(
            p =>
              p.documentType === patient.idIdentificationType.id &&
              p.document === patient.identification
          )
        ) {
          isItLoaded = true;
        }
      });

      if (isItLoaded) return false;

      this.showGrid = true;
      this.showGridAppointment = true;
      if (
        1005 === parseInt(StorageService.getUserData().rol) ||
        13 === parseInt(StorageService.getUserData().rol)
      ) {
        this.disableSaveButton = true;
        this.nameDissabled = true;
      } else if (order.status !== "SCHEDULED") {
        this.disableSaveButton = true;
        this.nameDissabled = true;
      }

      // const userData = StorageService.getUserData()
      // if (order.status !== 'RETURNED' && order.status !== 'SCHEDULED') this.disableSaveButton = true
      if (order.id) {
        this.order.deliveryAddress = `${this.nameNomenclature}  ${this.numberOne} # ${this.numberTwo} - ${this.numbreThree}`
        this.nameNomenclature = order.nameNomenclature
        this.numberOne = order.numberOne
        this.numberTwo = order.numberTwo
        this.numbreThree = order.numbreThree
      }
      this.createReminder = order.reminders && order.reminders.length > 0
      this.order.id = order.id
      this.order.status = order.status
      if (order.type !== "NO_STATUS") {
        switch (order.type) {
          case "EXCLUSIVE":
            this.order.orderType = this.itemTypeOrder[0].id;
            break;
          case "INTEGRATED":
            this.order.orderType = this.itemTypeOrder[1].id;
            break;
        }
      }
      this.order.number = order.number
      this.order.deliveryDate = order.shippingDate
      this.order.notApplyShippingFee = order.notApplyShippingFee

      this.selectedScheduleRange = order.idProviderScheduleRange
        ? order.idProviderScheduleRange.id + ""
        : "";

      if (!this.authorizationsLoaded) {
        this.patientListData = [];
        this.orderDetail = [];
      }

      order.orderPatients.forEach(orderPatient => {
        let patient = orderPatient.idPatient;
        this.patientListData.push({
          id: patient.id,
          documentType: patient.idIdentificationType.id,
          document: patient.identification,
          fullname: patient.name,
          address: patient.address,
          cellPhoneNumber: patient.mobilePhone,
          phoneNumber: patient.phone,
          idIncomeGroup: patient.idIncomeGroup ? patient.idIncomeGroup.id : "-",
          isPac: +patient.PAC === 1,
          isPolicy: +patient.policy === 1
        });
      });

      let orderDetails = order.orderDetails;
      this.patient.document = order.idPatient.identification;
      this.patient.fullname = order.idPatient.name;

      this.searchIdentification = order.idPatient.identification
      this.searchIdentificationType = order.idPatient.idIdentificationType.code

      orderDetails.forEach(orderDetail => {
        this.orderCode = orderDetail.code;
        this.scaleFee = orderDetail.slidingScaleFee;
        this.deliveryNumber = orderDetail.number;
        this.paymentType = orderDetail.paymentType;
        if (orderDetail.idProvider)
          this.order.providerId = orderDetail.idProvider.id;

        this.addOrderDetail(false, orderDetail.id, orderDetail.status);

        if (orderDetail.orderDetailMedicines) {
          orderDetail.orderDetailMedicines.forEach(medicine => {
            this.plu = medicine.pluCode;
            this.description = medicine.description;
            this.count = medicine.quantity;
            this.nextShippingDate = medicine.nextShippingDate;
            this.selectOrderCode = orderDetail.code;
            this.addMedicines(false, medicine.id, medicine.idMedicineCondition);
          });
        }
      });

      if (order.idCity) {
        this.location.branch = order.idProviderScheduleRange.idBranch.id;
        this.location.city = order.idCity.id;
        this.lastCitySelected = order.idCity.id;
        this.location.state = order.idCity.idState.id;

        await this.getBranches();
        await this.getCities();

        this.location.scheduleRange = order.idProviderScheduleRange.id;
      } else {
        this.location.scheduleRange = "";
        this.location.branch = "";
        this.location.city = "";
        this.location.state = "";
      }

      this.attachment = {
        name: order.fileName,
        fromService: true
      };
      this.observation = order.observation;
      this.note = order.note;

      this.authorizationsLoaded = true;
      this.patient = {};
      return true;
    },
    cancelOrder() {
      const user = JSON.parse(localStorage.getItem("user"));
      serviceOrder.cancelOrder(this.order.id, user["providerId"]).then(res => {
        this.closeOrder();
      });
    },
    searchAuthorizations() {
      if (this.$refs.validFormPatient.validate()) {
        this.searchButtonLoading = true
        this.searchIdentification = this.patient.document
        this.searchIdentificationType = this.patient.documentType

        let user = JSON.parse(localStorage.getItem("user"));

        if (user.branchType === "EXCLUSIVE") {
          serviceOrder
            .getAuthorizationsWithProvider(
              this.patient.documentType,
              this.patient.document,
              user.providerId
            )
            .then(response => {
              this.authorizationsLoaded = this.handleOrder(response.data);
              this.searchButtonLoading = false;
              this.getAllowedDate();
            })
            .catch(() => {
              this.searchButtonLoading = false;
              this.$notify({
                group: "app",
                type: "error",
                text:
                  "No se han encontrado autorizaciones para el paciente especificado."
              });
            });
        } else {
          serviceOrder
            .getAuthorizations(this.patient.documentType, this.patient.document)
            .then(response => {
              this.authorizationsLoaded = this.handleOrder(response.data);
              this.searchButtonLoading = false;
              this.getAllowedDate();
            })
            .catch(() => {
              this.searchButtonLoading = false;

              this.$notify({
                group: "app",
                type: "error",
                text:
                  "No se han encontrado autorizaciones para el paciente especificado."
              });
            });
        }
      }
    },
    prefijo(num) {
      return num < 10 ? "0" + num : num;
    },
    newDate(partes) {
      let date = new Date(0);
      date.setHours(partes[0]);
      date.setMinutes(partes[1]);
      return date;
    },
    getAllowedDate() {
      let data = {
        date: new Date().toISOString("YYYY-MM-DD").substr(0, 10),
        provider: StorageService.getUserData().providerId
      };
      // new Date().toISOString('YYYY-MM-DD').substr(0,10)
      let val = new Date().toISOString("YYYY-MM-DD").substr(0, 10);
      let theDate = dayjs(val);

      serviceCalendar
        .getAllowedDate(data)
        .then(result => {
          if (result.data.code.length === 0) {
            let sumDate = this.sumDateWeekend(theDate.format("YYYY/MM/DD"));
            serviceCalendar
              .getAllowedDate({
                date: sumDate.format("YYYY-MM-DD"),
                provider: StorageService.getUserData().providerId
              })
              .then(result => {
                for (let i = 0; i < result.data.code.length; i++) {
                  this.fechaAllowed = sumDate.add(
                    parseInt(result.data.code[i].daysAnswer),
                    "day"
                  );
                  this.fechaAllowed = this.fechaAllowed.format("YYYY-MM-DD");
                  // this.order.deliveryDate = this.fechaAllowed
                }
              })
              .catch(erro => {
                console.log(erro);
              });
          } else {
            for (let i = 0; i < result.data.code.length; i++) {
              let otherFech = result.data.code[i].Date;
              if (otherFech === val) {
                let dateDesde = this.newDate(
                  new Date()
                    .toString()
                    .substring(16, 24)
                    .split(":")
                );
                let dateHasta = this.newDate(
                  result.data.code[0].closingDate.split(":")
                );

                let minutos = (dateHasta - dateDesde) / 1000 / 60;
                let horas = Math.floor(minutos / 60);
                minutos = minutos % 60;
                let total =
                  this.prefijo(parseInt(horas)) +
                  ":" +
                  this.prefijo(parseInt(minutos));
                let validNumber = this.validarNumber(total);
                if (validNumber) {
                  theDate = dayjs(otherFech).add(1, "day");
                  let newFech = this.callDate(
                    theDate.format("YYYY/MM/DD"),
                    StorageService.getUserData().idBranch
                  );
                  if (newFech.code === undefined) {
                    let sumDate = this.sumDateWeekend(
                      theDate.format("YYYY-MM-DD")
                    );
                    this.fechaAllowed = sumDate.format("YYYY-MM-DD");
                    // this.order.deliveryDate = this.fechaAllowed
                  } else {
                    this.fechaAllowed = theDate.format("YYYY-MM-DD");
                    // this.order.deliveryDate = this.fechaAllowed
                  }
                } else {
                  theDate = theDate.add(
                    parseInt(result.data.code[i].daysAnswer),
                    "day"
                  );
                  let newFech = this.callDate(
                    theDate.format("YYYY/MM/DD"),
                    StorageService.getUserData().idBranch
                  );
                  if (newFech.code === undefined) {
                    let sumDate = this.sumDateWeekend(
                      theDate.format("YYYY-MM-DD")
                    );
                    this.fechaAllowed = sumDate.format("YYYY-MM-DD");
                    // this.order.deliveryDate = this.fechaAllowed
                  } else {
                    this.fechaAllowed = theDate.format("YYYY-MM-DD");
                    // this.order.deliveryDate = this.fechaAllowed
                  }
                }
              } else {
                // Sabado
                if (dayjs(theDate).day() === 6) {
                  this.fechaAllowed = theDate.add(2, "day");
                  this.fechaAllowed = this.fechaAllowed.format("YYYY-MM-DD");
                  // this.order.deliveryDate = this.fechaAllowed
                }
                // Domingo
                if (dayjs(theDate).day() === 0) {
                  this.fechaAllowed = theDate.add(1, "day");
                  this.fechaAllowed = this.fechaAllowed.format("YYYY-MM-DD");
                  // this.order.deliveryDate = this.fechaAllowed
                }
              }
            }
          }
          data = {};
        })
        .catch(erro => {
          console.log(erro);
        });
    },
    validarNumber(number) {
      return number.includes("-");
    },
    callDate(date, id) {
      let data = {
        date: date,
        provider: id
      };
      let response = [];

      serviceCalendar
        .getAllowedDate(data)
        .then(result => {
          response.push(result.data);
        })
        .catch(erro => {
          console.log("Error: ", erro);
        });

      return response;
    },
    sumDateWeekend(date) {
      let sum = dayjs(date);
      switch (sum.day()) {
        case 6: // Sabado
          sum = sum.add(1, "day");
        case 0: // Domingo
          sum = sum.add(1, "day");
        default:
          // eslint-disable-next-line no-self-assign
          sum = sum;
      }
      return sum;
    },
    showNoCoverageForAnyCity(type) {
      this.$notify({
        group: "app",
        type,
        text: i18n.t("app.scheduling.no-coverage-area")
      });
    }
  },
  computed: {
    isCityDisabled() {
      return this.location.state === "";
    },
    isBranchDisabled() {
      return this.location.city === "";
    },
    isScheduleRangeDisabled() {
      return this.location.branch === "";
    },
    notes: {
      get() {
        let slidingScaleFeeTotal = this.orderDetail
          .map(item => item.scaleFee)
          .reduce((a, b) => a + +b, 0);

        let scheduleRange = {};

        if (this.location && this.location.scheduleRange) {
          scheduleRange = this.scheduleRanges.find(
            scheduleRange => scheduleRange.id === this.location.scheduleRange
          );
        }

        let shippingFee =
          scheduleRange && scheduleRange.shippingFee
            ? scheduleRange.shippingFee
            : 0;

        if (this.order.notApplyShippingFee) {
          shippingFee = 0;
        }
        let recoveryFee = "";
        let ordersNumbers = [];
        this.orderDetail.map(item => {
          if (item.paymentType === "CUOTA DE RECUPERACION") {
            ordersNumbers.push(item.orderCode);
          }
        });
        if (ordersNumbers.length > 0) {
          recoveryFee =
            ", ademas se le cobrará el 10% del valor de los medicamentos de la orden ";
          ordersNumbers.map(item => (recoveryFee += `${item} `));
        }

        const medicineText =
          this.dataMedicines && this.dataMedicines.length > 0
            ? this.dataMedicines
              .map(medicine => {
                return `${medicine.count} de ${medicine.description}`;
              })
              .join("; ")
            : "";
        return (
          `Su domicilio queda programado para el día ${
          this.order.deliveryDate ? this.order.deliveryDate : " "
          } ` +
          `en el horario ${
          scheduleRange && scheduleRange.range ? scheduleRange.range : " "
          }, ` +
          `los medicamentos que entregaremos serán ${medicineText}, ` +
          `El valor de la cuota moderadora será máximo ${
          slidingScaleFeeTotal ? slidingScaleFeeTotal : "0"
          }. ` +
          ` ${recoveryFee} ` +
          "Podría ser un valor inferior de acuerdo al precio del medicamento. " +
          `El valor del envío es ${shippingFee}. ` +
          `Para un total de ${slidingScaleFeeTotal + shippingFee}. ` +
          "Como el domicilio queda programado, los medicamentos ya no podrán ser entregados en la farmacia. " +
          "Recuerde esperar al mensajero con documento original o copia del mismo y el valor en efectivo para el pago. " +
          "¡Que tenga un feliz día!"
        );
      },
      set(notes) {
        this.notes = notes;
      }
    }
  }
};
